import { connect } from "react-redux";
import { withRouter } from "react-router";
import SelectPackageSubcat from "landing_pages/components/select_package_subcat";

export default withRouter(connect(() => ({}))(SelectPackageSubcat));
